const AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION = "dev.azure.com/build-definition";
const AZURE_DEVOPS_HOST_ORG_ANNOTATION = "dev.azure.com/host-org";
const AZURE_DEVOPS_PROJECT_ANNOTATION = "dev.azure.com/project";
const AZURE_DEVOPS_README_ANNOTATION = "dev.azure.com/readme-path";
const AZURE_DEVOPS_REPO_ANNOTATION = "dev.azure.com/project-repo";
const AZURE_DEVOPS_DEFAULT_TOP = 10;

export { AZURE_DEVOPS_BUILD_DEFINITION_ANNOTATION, AZURE_DEVOPS_DEFAULT_TOP, AZURE_DEVOPS_HOST_ORG_ANNOTATION, AZURE_DEVOPS_PROJECT_ANNOTATION, AZURE_DEVOPS_README_ANNOTATION, AZURE_DEVOPS_REPO_ANNOTATION };
//# sourceMappingURL=constants.esm.js.map
